// Vite entrypoint for login and registration pages
import '../js/shared/fonts.ts'
import { initAppsignal } from '../js/shared/appsignal.ts'
initAppsignal()
import '../css/style.css'
import '../js/components'
import { initI18n, t } from '../js/shared/i18n.ts'
import { login, register, redirectIfAuthenticated, postLoginPath, googleOAuth, facebookOAuth, appleOAuth } from '../js/shared/auth.ts'
import { dashboard_path } from '../js/shared/routes'

document.addEventListener('DOMContentLoaded', async () => {
  await initI18n();
  redirectIfAuthenticated();

  // Login form handler
  const loginForm = document.getElementById('loginForm');
  if (loginForm) {
    loginForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const errorEl = document.getElementById('authError');
      // The submit button lives in .au-actions outside the <form> and is
      // wired via form="loginForm" — querySelector inside the form misses
      // it. Look outside as well so disabled-state still toggles.
      const submitBtn = loginForm.querySelector('button[type="submit"]') ||
                        document.querySelector(`button[type="submit"][form="${loginForm.id}"]`);
      errorEl.hidden = true;

      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;

      submitBtn.disabled = true;
      try {
        await login(email, password);
        window.location.href = postLoginPath();
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        submitBtn.disabled = false;
      }
    });
  }

  // Register form handler
  const registerForm = document.getElementById('registerForm');
  if (registerForm) {
    registerForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const errorEl = document.getElementById('authError');
      // Submit button is in .au-actions outside the <form> — same pattern
      // as login above.
      const submitBtn = registerForm.querySelector('button[type="submit"]') ||
                        document.querySelector(`button[type="submit"][form="${registerForm.id}"]`);
      errorEl.hidden = true;

      const name = document.getElementById('name').value;
      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;
      const passwordConfirmation = document.getElementById('passwordConfirmation').value;

      if (password !== passwordConfirmation) {
        errorEl.textContent = t('auth.passwordMismatch');
        errorEl.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      try {
        await register(name, email, password, passwordConfirmation);
        window.location.href = dashboard_path();
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        submitBtn.disabled = false;
      }
    });
  }

  // Google OAuth button
  const googleBtn = document.getElementById('btnGoogleAuth');
  if (googleBtn) {
    googleBtn.addEventListener('click', () => googleOAuth());
  }

  // Facebook OAuth button (only rendered when FACEBOOK_APP_ID is set)
  const facebookBtn = document.getElementById('btnFacebookAuth');
  if (facebookBtn) {
    facebookBtn.addEventListener('click', () => facebookOAuth());
  }

  // Apple OAuth button (only rendered when APPLE_CLIENT_ID is set)
  const appleBtn = document.getElementById('btnAppleAuth');
  if (appleBtn) {
    appleBtn.addEventListener('click', () => appleOAuth());
  }
});
